var _path, _path2, _path3, _circle, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.65211 2.5504C8.61689 2.34006 9.61884 2.22925 10.6467 2.22925C14.3862 2.22925 17.783 3.69604 20.2934 6.08566M4.44708 3.67404C3.17691 4.30276 2.01586 5.11865 1 6.08566",
    stroke: "#E7E9EF",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.47315 6.67889C6.0589 7.14444 4.77853 7.90477 3.70472 8.88719C3.59796 8.98487 3.49323 9.08474 3.39062 9.18674M12.1888 6.26001C12.3342 6.28036 12.4785 6.3037 12.6219 6.32999C14.6802 6.7074 16.5269 7.69004 17.9708 9.08663C18.0451 9.15853 18.1184 9.23153 18.1905 9.3056",
    stroke: "#E7E9EF",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.82617 1L18.6245 17.7983",
    stroke: "#E7E9EF",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5851,
    cy: 17.1545,
    r: 1.32096,
    fill: "#E7E9EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8961 13.1596C13.0586 12.2528 11.8594 11.6848 10.5276 11.6848C9.23596 11.6848 8.06907 12.219 7.23584 13.0785",
    stroke: "#E7E9EF",
    strokeWidth: 1.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetwork);
export default __webpack_public_path__ + "static/media/network.ca424225a2952df4b93ae4ef089b6aa0.svg";
export { ForwardRef as ReactComponent };